function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgOcr = function SvgOcr(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 16 16",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.6 12.2v-1.5h5.3v1.5zm0-3.1V7.6h7.6v1.5zm0-3V4.6h7.6v1.5zM2.5 16h.6c.6 0 .6 0 .6-.6s0-.6-.6-.6h-.6c-.8 0-1.3-.5-1.3-1.3v-.6c0-.6 0-.6-.6-.6s-.6-.1-.6.5v.6C0 15.1.9 16 2.5 16m10.2 0h.8c1.7 0 2.5-.9 2.5-2.5v-.6c0-.6 0-.6-.6-.6s-.6 0-.6.6v.6c0 .8-.5 1.3-1.3 1.3h-.6c-.6 0-.6 0-.6.6-.1.6-.1.6.4.6M.6 3.8c.6 0 .6 0 .6-.6v-.7c0-.8.5-1.3 1.3-1.3h.6c.6 0 .6 0 .6-.6s.1-.6-.5-.6h-.7C.9 0 0 .9 0 2.5v.6c0 .7 0 .7.6.7m14.8 0c.6 0 .6 0 .6-.6v-.7C16 .9 15.1 0 13.5 0h-.6c-.6 0-.6 0-.6.6s0 .6.6.6h.6c.8 0 1.3.5 1.3 1.3v.6c-.1.7-.1.7.6.7",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgOcr);
export default ForwardRef;